// visibility
// https://git.hubteam.com/HubSpot/Puma/blob/master/puma/static/js/frameworkTypes/types/VisibilityStatus.ts
export const CUSTOMER_FACING = 'Customer-facing';
export const INTERNAL_ONLY = 'Internal only';

// status
// https://git.hubteam.com/HubSpot/Puma/blob/master/puma/static/js/frameworkAppSettings/constants/AppSettings.ts
export const DEPRECATED = 'Deprecated';
export const IN_DEVELOPMENT = 'In development';
export const LIVE = 'Live';